import React from 'react'
import { NewProfilePic } from '../img/index'

const ABOUT_ME_TEXT = [
  {
    id: 'first-p-about',
    content:
      "ℹ️ I'm Alladin Daher, born and raised in Uppsala, Sweden. My journey began in the world of sports and coaching, where I honed skills in teamwork and discipline. Over time, my passion shifted towards technology, leading me to pursue a two-year Frontend Development program at KYH in Stockholm, Sweden.",
  },
  {
    id: 'second-p-about',
    content:
      '👨‍💻 Combining creativity with a solid educational foundation and practical experience, I enjoy tackling design challenges, crafting intuitive user interfaces, and developing robust websites and applications.',
  },
  {
    id: 'third-p-about',
    content:
      '🏋️ Outside of coding, I’m often found working out, playing football, or spending quality time with family and friends.',
  },
];

const About = () => {
  return (
    <section id="about" className="about-mf sect-pt4 route">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="box-shadow-full">
              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-sm-6 col-md-5">
                      <div className="about-img" style={{ textAlign: 'center' }}>
                        <img
                          src={NewProfilePic}
                          alt="profile pic"
                          style={{ height: '275px', width: '275px'}}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12">
                    <div className="about-me">
                      <div className="title-box-2">
                        <h5 className="title-left">Tech Stack</h5>
                      </div>

                      <div className="skills-text">
                        <ul className="skills-list">
                          {[
                            { icon: 'logos:html-5', text: 'HTML5' },
                            { icon: 'logos:css-3', text: 'CSS3' },
                            { icon: 'logos:javascript', text: 'Javascript' },
                            { icon: 'logos:typescript-icon', text: 'Typescript' },
                            { icon: 'logos:react', text: 'React' },
                            { icon: 'logos:nextjs', text: 'Next' },
                            { icon: 'emojione:mobile-phone', text: 'React Native' },
                            { icon: 'logos:nodejs', text: 'Node' },
                            { icon: 'logos:firebase', text: 'Firebase' },
                            { icon: 'devicon:tailwindcss', text: 'Tailwind' },
                            { icon: 'logos:figma', text: 'Figma' },
                            { icon: 'logos:git', text: 'Git' },
                          ].map((skill, index) => (
                            <li key={index}>
                              <iconify-icon data-icon={skill.icon} /> {skill.text}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="about-me pt-4 pt-md-0">
                    <div className="title-box-2">
                      <h5 className="title-left">About Me</h5>
                    </div>
                    {ABOUT_ME_TEXT.map((content) => {
                      return (
                        <p className="lead" key={content.id}>
                          {content.content}
                        </p>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
